import * as React from 'react';
import { ReviewsViewModel } from 'models';
import { LocalizedText } from 'bernie-l10n';
import { ErrorBoundary } from 'bernie-view';
import { Reviews } from 'components/infosite/property-details/reviews';

interface HotelReviewProps {
  reviews: ReviewsViewModel;
  header: string;
  isRefreshedHISLayout?: boolean;
}

const HotelReviews: React.FunctionComponent<HotelReviewProps> = ({ reviews, header, isRefreshedHISLayout }) => (
  <section>
    <h2 className="is-visually-hidden">
      <LocalizedText message={header} />
    </h2>
    <ErrorBoundary label="hotel.information.details.reviews">
      <Reviews reviews={reviews} isRefreshedHISLayout={isRefreshedHISLayout} />
    </ErrorBoundary>
  </section>
);

export { HotelReviews };
